<template>
  <div class="wg-row" style="justify-content:space-around;">
    <button class="small" @click="exportToCsv('categories')">
      <img :src="$anm22.icons.getWorldIcon('download')" />
      <div>{{ $anm22.strLang(lang, "Categories", "Categorie") }}</div>
    </button>
    <button class="small" @click="exportToCsv('products')">
      <img :src="$anm22.icons.getWorldIcon('download')" />
      <div>{{ $anm22.strLang(lang, "Products", "Prodotti") }}</div>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {},
  data() {
    return {
      delimiter: ";",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      licenseSelected: (state) => state.licenseSelected,
    }),
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.licenseSelected
      );
    },
  },
  methods: {
    async exportToCsv(type) {
      try {
        const response = await this.$http.get('inventory/export-csv-' + type);

        let csvContent = "data:text/csv;charset=utf-8,";
        response.data.csvData.forEach(row => {
          csvContent += row.join(this.delimiter) + '\n';
        })

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", type + ".csv");
        link.click();
      } catch(e) {}
    }
  },
  created() {},
};
</script>

<style lang="scss" scoped>

</style>
